/**
 * Actions used by the "Queries" hub. For historic reasons these are required by some work item controls.
 */
export namespace WorkItemViewActions {
    export const WORKITEM_VIEW_MESSAGE_CHANGE = "work-item-view-message-change";
    export const WORKITEM_VIEW_INFO_CHANGE = "work-item-view-info-change";
}
